/**
 * Creates the binding for the logging function that will hide the console logs if the application is running in
 * production mode. This a global function that is attached to the application during the loading of the main javascript.
 * Additional changes may be required for additional logging later.
 */
export const setLogger = () => {
  if (process.env.NODE_ENV !== 'production') {
    window.logger = {
      log: window.console.log.bind(window.console, `[LOG]::${new Date().toLocaleTimeString()}:: %s`),
      error: window.console.error.bind(window.console, `[ERROR]::${new Date().toLocaleTimeString()}:: %s`),
    };
  } else {
    // When the application is running in a mode that does not have the logging binded, it should call an empty function. This is to prevent crashes.
    window.logger = {
      log() {},
      error() {},
    };
  }
};
